export default __webpack_public_path__ + "static/media/Community_Home.bddadc06.svg";